// src/components/ImageProvider.js

import { PortableText } from '@portabletext/react';
import { createClient } from '@sanity/client';
import { createContext, useContext, useEffect, useState } from 'react';

const ImageContext = createContext();

const client = createClient({
  projectId: 'axwknhfh', // Replace with your Sanity project ID
  dataset: 'production', // Replace with your dataset
  apiVersion: '2024-12-22', // Use a recent date
  useCdn: true, // Enable CDN for faster response
});

export const ImageProvider = ({ children }) => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    client
      .fetch(
        `*[_type in ["HomeImageContent", "general", "HomeSwiper" , "ImageGizmo" , "TextGizmo" , "InsightsImageContent" , "HomeOverview"]]{
          title, NavbarTitle, sectionTitle, Sectitle, description, content, btnlabel, 
          file{ 
            asset->{
              _id,
              url,
              metadata
            }
          },
          altText
        }`
      )
      .then((data) => setImages(data || []))
      .catch((err) => console.error('Error fetching images:', err));
  }, []);

  return <ImageContext.Provider value={images}>{children}</ImageContext.Provider>;
};

export const useImages = () => useContext(ImageContext);

// A reusable component to render Portable Text content
export const PortableTextRenderer = ({ content }) => {
  if (!content) return null;

  return (
    <PortableText
      value={content}
      components={{
        block: {
          // Customize how different blocks are rendered
          normal: ({ children }) => <p>{children}</p>,
          h1: ({ children }) => <h1 className="text-2xl font-bold">{children}</h1>,
          h2: ({ children }) => <h2 className="text-xl font-semibold">{children}</h2>,
        },
        marks: {
          link: ({ children, value }) => (
            <a href={value.href} target="_blank" rel="noopener noreferrer" className="text-blue-500">
              {children}
            </a>
          ),
        },
        list: {
          bullet: ({ children }) => <ul className="list-disc pl-5">{children}</ul>,
          number: ({ children }) => <ol className="list-decimal pl-5">{children}</ol>,
        },
      }}
    />
  );
};
